const state = {
  levelData: null,
}

const getters = {
}

const mutations = {
  setLevelData (state, v) {
    state.levelData = v
  },
}

const actions = {
  level ({ state, commit, rootState }, params) {
    return rootState.axios.get('/quiz/v1frontend/respondence/level', { params }).then(res => {
      commit('setLevelData', res.data.model)
      return res
    })
  },
  searchLevel ({ state, commit, rootState }, params) {
    return rootState.axios.get('/quiz/v1frontend/question/search-level', { params })
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/quiz/v1frontend/respondence/view', { params })
  },
  answered ({ state, commit, rootState }, params) {
    return rootState.axios.post('/quiz/v1frontend/respondence/answered', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
